<template>
  <button id="NUMBER_6" name="6" class="btn num-btn" data-vcode="NUMBER_6" aria-label="6 MNO">
    <div class="digit">6</div>
    <div class="letters">MNO</div>
  </button>
</template>
<script>
export default {};
</script>
